import React from 'react';
import DOMPurify from 'dompurify';

function getDotClass(type) {
  if (type === 'payment_received') return 'green';
  if (type === 'campaign_assigned') return 'gold';
  if (type === 'tweet_submitted') return 'blue';
  if (type === 'tweet_verified') return 'green';
  return 'gray';
}

export default function FeedItem({ type, text, time }) {
  return (
    <div className="feed-item">
      <div className={`feed-dot ${getDotClass(type)}`} />
      <div className="feed-body">
        <div
          className="feed-text"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
        />
        <div className="feed-time">{time}</div>
      </div>
    </div>
  );
}
